import React from 'react';

import { useExistsAtLeastOneExpectation } from 'hooks/reports/utilization/package-utilization/useExpectations';

import HeaderWithExpectations from './HeaderWithExpectations';
import HeaderWithoutExpectations from './HeaderWithoutExpectations';

const HeaderSection = (): JSX.Element => {
  const { data: existsAtLeastOne, isLoading, isError } = useExistsAtLeastOneExpectation({});

  if (isLoading || isError || !existsAtLeastOne) {
    return <HeaderWithoutExpectations />;
  }

  return <HeaderWithExpectations />;
};

export default HeaderSection;
